import React, { useState } from 'react';
import AllRoasStatisticsGraph from './AllRoasStatisticsGraph';
import moment from 'moment';

let initParam = {
  sDate: moment().add(-6, 'month').format('YYYYMMDD'),
  eDate: moment().add(-1, 'day').format('YYYYMMDD'),
};

const RoasStatistics = () => {
  // 공통 필터에서 초기값 받아왔는지 확인
  const [params] = useState(initParam);

  return (
    <>
      <AllRoasStatisticsGraph params={{ ...params }} />
    </>
  );
};

export default RoasStatistics;
